module.exports = __webpack_public_path__ + "img/icon-tips.41408211.png";